export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1766678340672-51e6be3a64d8?q=75&w=1600&auto=format&fit=crop",
  portAerial: "https://images.unsplash.com/photo-1591907303049-a5e5df26bcb9?q=70&w=1200&auto=format&fit=crop",
  montreal: "https://images.unsplash.com/photo-1594825505684-5a5a5b18b544?q=70&w=1200&auto=format&fit=crop",
  containers: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?q=70&w=1200&auto=format&fit=crop",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PORTS = [
  {
    id: "abidjan", name: "Abidjan", country: { fr: "Côte d'Ivoire", en: "Côte d'Ivoire" },
    days: 38, span: "md:col-span-8", tint: "from-orange-900/60",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Abidjan_port_warehouses_Cote_d%27Ivoire.jpg/1280px-Abidjan_port_warehouses_Cote_d%27Ivoire.jpg",
    desc: { fr: "Premier port d'Afrique de l'Ouest francophone, porte d'entrée du marché ivoirien et de l'hinterland sahélien.", en: "Leading port of francophone West Africa, gateway to the Ivorian market and the Sahel hinterland." },
  },
  {
    id: "dakar", name: "Dakar", country: { fr: "Sénégal", en: "Senegal" },
    days: 30, span: "md:col-span-4", tint: "from-sky-900/60",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/DakarHarbourAerial.JPG/1280px-DakarHarbourAerial.JPG",
    desc: { fr: "L'escale la plus proche du Canada — notre transit le plus rapide vers l'Afrique de l'Ouest.", en: "The closest call to Canada — our fastest transit to West Africa." },
  },
  {
    id: "douala", name: "Douala", country: { fr: "Cameroun", en: "Cameroon" },
    days: 46, span: "md:col-span-4", tint: "from-emerald-900/60",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Port_autonome_de_Douala_1.jpg/1280px-Port_autonome_de_Douala_1.jpg",
    desc: { fr: "Cœur économique du Cameroun et porte d'entrée du Tchad et de la Centrafrique.", en: "Economic heart of Cameroon and gateway to Chad and Central African Republic." },
  },
  {
    id: "lome", name: "Lomé", country: { fr: "Togo", en: "Togo" },
    days: 36, span: "md:col-span-4", tint: "from-amber-900/60",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Container_ships_at_Lome_port_%28cropped%29.jpg/1280px-Container_ships_at_Lome_port_%28cropped%29.jpg",
    desc: { fr: "Port en eau profonde, hub régional de transbordement vers le Niger et le Burkina Faso.", en: "Deep-water port, regional transshipment hub towards Niger and Burkina Faso." },
  },
  {
    id: "matadi", name: "Matadi", country: { fr: "RD Congo", en: "DR Congo" },
    days: 62, span: "md:col-span-4", tint: "from-indigo-900/60",
    img: "https://upload.wikimedia.org/wikipedia/commons/9/9f/Port_de_Matadi_%284944741356%29.jpg",
    desc: { fr: "Le seul port maritime de la RD Congo, sur le fleuve Congo — la porte de Kinshasa.", en: "DR Congo's only seaport, on the Congo River — the gateway to Kinshasa." },
  },
  {
    id: "conakry", name: "Conakry", country: { fr: "Guinée", en: "Guinea" },
    days: 33, span: "md:col-span-6", tint: "from-rose-900/60",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Port_autonome_de_Conakry.jpg/1280px-Port_autonome_de_Conakry.jpg",
    desc: { fr: "Capitale guinéenne et point d'appui des exportations minières de bauxite.", en: "Guinean capital and stronghold of bauxite mining exports." },
  },
  {
    id: "port-gentil", name: "Port-Gentil", country: { fr: "Gabon", en: "Gabon" },
    days: 52, span: "md:col-span-6", tint: "from-teal-900/60",
    img: "https://upload.wikimedia.org/wikipedia/commons/8/8c/Port_Gentil_Ferries_%2845310769765%29.jpg",
    desc: { fr: "Capitale économique du Gabon, au cœur de la zone pétrolière et forestière.", en: "Economic capital of Gabon, at the heart of the oil and timber region." },
  },
];

// Coordonnées réelles de l'entreprise.
export const COMPANY = {
  name: "Sodimax Logistics",
  phone: "(514) 974-2948",
  fax: "(514) 400-4076",
  email: "Patrice_Doffou.Nguessan@sodimaxlog.com",
  quoteEmail: "Patrice_Doffou.Nguessan@sodimaxlog.com",
  invoiceEmail: "Patrice_Doffou.Nguessan@sodimaxlog.com",
  addressLine1: "2395, John-Campbell",
  addressLine2: "Montréal QC H8N 1C5, Canada",
  bank: {
    beneficiary: "Sodimax Logistics",
    bank: "Banque Nationale du Canada",
    institution: "006",
    transit: "01151",
    account: "102 458 7",
    swift: "BNDCCAMMXXX",
    currency: "CAD / USD / XOF",
  },
};
